function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 6 Copy");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "News",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-/-News-Detail",
  transform: "translate(-192.000000, -2800.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6-Copy",
  transform: "translate(213.000000, 2819.000000) scale(-1, 1) translate(-213.000000, -2819.000000) translate(192.000000, 2800.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.2145626,1.75445035 C40.878905,4.36897815 41.496116,10.3509199 41.6473604,15.7145386 C41.7863719,21.0892782 41.4583048,25.8557037 39.1162395,29.6979808 C36.7864072,33.5280249 32.4670427,36.4583868 27.8451892,37.4381397 C23.2222236,38.4301255 18.2989933,37.4715024 14.0163278,35.7366392 C9.7470074,33.9906551 6.13270907,31.4550858 3.53819892,28.0754389 C0.957033874,24.7058007 -0.592109992,20.4920849 0.214156557,16.6954036 C1.03265612,12.8976101 4.205454,9.52908406 7.92095267,6.92567718 C11.6486844,4.31226147 15.9057717,2.47508583 21.3839359,1.17949889 C26.8621001,-0.116088047 33.5624531,-0.860077456 37.2145626,1.75445035",
  id: "Fill-6",
  fill: "#002C3E"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(5.931156, 4.077670)"
}, /*#__PURE__*/React.createElement("g", {
  id: "baseline-keyboard_backspace-24px",
  transform: "translate(14.827891, 14.827891) scale(-1, 1) translate(-14.827891, -14.827891) "
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 29.6557811 0 29.6557811 29.6557811 0 29.6557811"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FFFFFF",
  points: "25.9488085 13.592233 8.43954104 13.592233 12.8631951 9.15622242 11.1209179 7.41394528 3.70697264 14.8278906 11.1209179 22.2418358 12.8631951 20.4995587 8.43954104 16.0635481 25.9488085 16.0635481"
})))), /*#__PURE__*/React.createElement("g", {
  id: "ic-/2/-arrow-2",
  transform: "translate(5.931156, 4.077670)"
}))));

var SvgPrevArrow = function SvgPrevArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "38px",
    viewBox: "0 0 42 38",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrevArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/prev-arrow.0fc4a63a.svg";
export { ForwardRef as ReactComponent };